import React, { useState } from 'react';
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger, Input, Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@ncoder/ui';
import { GitBranch } from 'lucide-react';
import { BranchCard, BranchData } from '../../atoms/version-control/BranchCard';

interface BranchListProps {
  branches: BranchData[];
  onSwitch?: (branchName: string) => void;
  onMerge?: (branchName: string) => void;
  onCreatePR?: (branchName: string) => void;
  onCreateBranch?: (branchName: string, fromBranch: string) => void;
}

export const BranchList: React.FC<BranchListProps> = ({
  branches,
  onSwitch,
  onMerge,
  onCreatePR,
  onCreateBranch,
}) => {
  const [newBranchName, setNewBranchName] = useState('');
  const [fromBranch, setFromBranch] = useState(branches.find(b => b.isDefault)?.name || branches[0]?.name || '');
  const [isOpen, setIsOpen] = useState(false);

  const handleCreateBranch = () => {
    if (newBranchName.trim() && onCreateBranch) {
      onCreateBranch(newBranchName, fromBranch);
      setNewBranchName('');
      setIsOpen(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-section-title">Repository Branches</h3>
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
          <DialogTrigger asChild>
            <Button>
              <GitBranch className="h-4 w-4 mr-2" />
              New Branch
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Create New Branch</DialogTitle>
              <DialogDescription>
                Create a new branch from the current branch
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              <div>
                <Label htmlFor="branch-name">Branch Name</Label>
                <Input
                  id="branch-name"
                  placeholder="feature/new-feature"
                  value={newBranchName}
                  onChange={(e) => setNewBranchName(e.target.value)}
                />
              </div>
              <div>
                <Label>Create from</Label>
                <Select value={fromBranch} onValueChange={setFromBranch}>
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {branches.filter(b => b.status === 'active').map((branch) => (
                      <SelectItem key={branch.name} value={branch.name}>
                        {branch.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setIsOpen(false)}>Cancel</Button>
              <Button onClick={handleCreateBranch}>Create Branch</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="space-y-3">
        {branches.map((branch) => (
          <BranchCard
            key={branch.name}
            branch={branch}
            onSwitch={onSwitch}
            onMerge={onMerge}
            onCreatePR={onCreatePR}
          />
        ))}
      </div>
    </div>
  );
};
